import { render, staticRenderFns } from "./Destroy.vue?vue&type=template&id=2b4b7540&scoped=true"
import script from "./Destroy.vue?vue&type=script&lang=js"
export * from "./Destroy.vue?vue&type=script&lang=js"
import style0 from "./Destroy.vue?vue&type=style&index=0&id=2b4b7540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b7540",
  null
  
)

export default component.exports